import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  List,
  ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ContentTab({ data }) {
  console.log("Content metadata in ContentTab:", data) // Log the content metadata to verify it's being passed correctly;
  const content = data

  return (
    <Box>
      <Typography variant="h6" mb={1}>Course Content</Typography>

      {content.map((module) => (
        <Accordion key={module.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={600}>{module.title}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            {module.topics.map((topic) => (
              <Box key={topic.id} mb={1}>
                <Typography fontWeight={500}>
                  {topic.title}
                </Typography>

                <List dense>
                  {topic.subTopics.map((sub) => (
                    <ListItem key={sub.id} sx={{ pl: 2 }}>
                      • {sub.title}
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}

    </Box>
  );
}
